var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionbankRecordSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_questionbank_record_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u505A\\u9898\\u8BB0\\u5F55-\\u672A\\u5B8C\\u6210",
    transform: "translate(-714, -161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_questionbank_record_selected",
    transform: "translate(714, 161)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFA516",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,26 C21.9708333,26 26,21.9708333 26,17 C26,12.0291667 21.9708333,8 17,8 C12.0291667,8 8,12.0291667 8,17 C8,21.9708333 12.0291667,26 17,26 Z M17,24.6666667 C14.2609544,24.6666667 11.7299658,23.2054255 10.360439,20.8333447 C8.99091209,18.461264 8.99091209,15.538736 10.360439,13.1666553 C11.7299658,10.7945745 14.2609544,9.33333333 17,9.33333333 C21.2341677,9.33333333 24.6666272,12.7658323 24.6666272,17 C24.6666272,21.2341677 21.2341677,24.6666667 17,24.6666667 L17,24.6666667 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0183333,20.365 C13.8500287,20.5364198 13.7869667,20.7851334 13.8532613,21.0160365 C13.9195559,21.2469395 14.1049532,21.424318 14.3385601,21.4803449 C14.572167,21.5363718 14.8178512,21.4623815 14.9816667,21.2866667 L18.1983333,17.9283333 C18.3467189,17.7730422 18.429414,17.5664539 18.4291672,17.3516667 L18.4291672,13.6666667 C18.4291672,13.2984768 18.1306898,13 17.7625,13 C17.3943102,13 17.0958333,13.2984768 17.0958333,13.6666667 L17.0958333,17.1508333 L14.0183333,20.365 L14.0183333,20.365 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionbankRecordSelected);
export default __webpack_public_path__ + "static/media/icon_questionbank_record_selected.svg";
export { ForwardRef as ReactComponent };